var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPointer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 27,
    viewBox: "0 0 25 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7919 24.9279C11.9654 25.1737 12.2537 25.3171 12.5575 25.3171C12.8614 25.3171 13.1497 25.1738 13.3232 24.9279C13.8613 24.1657 14.4849 23.3406 15.1418 22.4716C16.5438 20.6168 18.0968 18.5623 19.2902 16.4932C20.6965 14.0554 21.3939 11.9535 21.3939 10.0762C21.3939 5.45717 17.4189 1.71935 12.5575 1.71935C7.69616 1.71935 3.72118 5.45717 3.72118 10.0762C3.72118 11.9535 4.41852 14.0554 5.82482 16.4932C7.01784 18.5614 8.57342 20.6195 9.97602 22.4752C10.6324 23.3437 11.2553 24.1678 11.7919 24.9279ZM12.5575 3.48726C16.422 3.48726 19.5461 6.45408 19.5461 10.0762C19.5461 11.6192 18.9435 13.4354 17.6725 15.6388C16.5338 17.6128 15.0273 19.6058 13.6474 21.4312C13.2713 21.9287 12.9047 22.4136 12.5575 22.8824C12.2104 22.4137 11.8438 21.9288 11.4678 21.4314C10.088 19.606 8.58135 17.6129 7.44259 15.6388C6.17161 13.4354 5.56901 11.6192 5.56901 10.0762C5.56901 6.45408 8.69307 3.48726 12.5575 3.48726Z",
    fill: "#7B788A",
    stroke: "#7B788A",
    strokeWidth: 0.409209
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5581 14.3568C15.0397 14.3568 17.0785 12.4475 17.0785 10.0761C17.0785 7.70468 15.0397 5.7954 12.5581 5.7954C10.0765 5.7954 8.03758 7.70468 8.03758 10.0761C8.03758 12.4475 10.0765 14.3568 12.5581 14.3568ZM12.5581 7.56331C14.0428 7.56331 15.2307 8.70159 15.2307 10.0761C15.2307 11.4506 14.0428 12.5889 12.5581 12.5889C11.0734 12.5889 9.88542 11.4506 9.88542 10.0761C9.88542 8.70159 11.0734 7.56331 12.5581 7.56331Z",
    fill: "#7B788A",
    stroke: "#7B788A",
    strokeWidth: 0.409209
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointer);
export default __webpack_public_path__ + "static/media/pointer.a5a69562614d7f4e43f9ab3503dddb3e.svg";
export { ForwardRef as ReactComponent };